import styles from '../../styles/styles.module.css';

function PageNotFound() {
    return (
        <h1 className={styles.title}>404: Oops! We can't find the page you're looking for!</h1>
    )
}

export default PageNotFound;